import { FC, useState } from 'react';
import './style.scss';

export enum MaskType {
  Start = 1,
  End,
}

export type MaskAttr = {
  type: MaskType;
  displayedCount: number;
};

type EstablishTextProps = {
  inputType: string;
  inputValue?: string;
  setInputValue?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyEnter?: () => void;
  placeholder?: string;
  disabled?: boolean;
  masked?: MaskAttr;
};

const mask = (target: String | undefined, attr: MaskAttr) => {
  if (!target) return '';

  switch (attr.type) {
    case MaskType.Start: {
      const visible = target.slice(-1 * attr.displayedCount);
      return visible.padStart(target.length, '*');
    }
    case MaskType.End: {
      const visible = target.slice(0, attr.displayedCount);
      return visible.padEnd(target.length, '*');
    }
  }
};

export const EstablishText: FC<EstablishTextProps> = (props) => {
  const { inputType, inputValue, setInputValue, onKeyEnter, placeholder, disabled, masked } = props;
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.nativeEvent.isComposing || e.key !== 'Enter') return;
    e.preventDefault();
    onKeyEnter && onKeyEnter();
  };
  const [hide, setHide] = useState<boolean>(true);
  return (
    <input
      className="establishText"
      type={inputType}
      value={masked && hide ? mask(inputValue, masked) : inputValue}
      onKeyDown={handleKeyDown}
      onChange={setInputValue}
      placeholder={placeholder}
      disabled={disabled}
      onFocus={() => setHide(false)}
    />
  );
};
